// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.title {
  font-size: 25px;
  display: block;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/est/estoque/filtro-estoque/filtro-estoque.component.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,cAAA;EACA,WAAA;AACJ","sourcesContent":[".title{\n    font-size: 25px;\n    display: block;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
